import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Dialog } from '@understory-io/leaf/dialog';
import { PickerRows } from './picker-rows';
import type { TicketVariantOption } from './types';

/**
 * Mobile presentation: the picker rows inside a `ModalDialog` (bottom sheet).
 * Edits are staged in local state and only committed to the parent via
 * `onSave`; dismissing the dialog discards them.
 */
export function TicketsDrawer({
  variants,
  quantities,
  seatStep,
  maxSeats,
  onSave,
  onClose,
}: {
  variants: TicketVariantOption[];
  quantities: Record<string, number>;
  seatStep: number;
  maxSeats?: number;
  onSave: (next: Record<string, number>) => void;
  onClose: () => void;
}) {
  const [staged, setStaged] = useState(quantities);

  return (
    <Dialog
      title={
        <FormattedMessage
          defaultMessage="Tickets"
          description="Tickets picker dialog heading"
        />
      }
      onClose={onClose}
      primaryAction={{
        appearance: 'primary',
        onClick: () => onSave(staged),
        children: (
          <FormattedMessage
            defaultMessage="Save"
            description="Tickets picker dialog confirm button"
          />
        ),
      }}
    >
      <PickerRows
        variants={variants}
        quantities={staged}
        seatStep={seatStep}
        maxSeats={maxSeats}
        onChange={setStaged}
      />
    </Dialog>
  );
}
